'use strict';
// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
module.exports = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/get-iterator-direct.js
// module id = 33
// module chunks = 0